/* TermPaymentAmounts.ts */
import { TermPaymentAmount } from './TermPaymentAmount';
export class TermPaymentAmounts {
    _paymentAmounts = [];
    _modified = false;
    onChange;
    /* ─────────────────────────────────────────── */
    constructor(paymentAmounts = []) {
        this.paymentAmounts = paymentAmounts;
        this.updateJsValues();
    }
    /* ===== modified flag (aggregate) ===== */
    get modified() {
        return this._modified || this._paymentAmounts.some((p) => p.modified);
    }
    set modified(v) {
        this._modified = v;
    }
    get hasModified() {
        return this.modified;
    }
    resetModified() {
        this.modified = false;
        this._paymentAmounts.forEach((p) => (p.modified = false));
    }
    /* ===== model/JS sync helpers ===== */
    updateModelValues() {
        this._paymentAmounts.forEach((p) => p.updateModelValues());
    }
    updateJsValues() {
        this._paymentAmounts.forEach((p) => p.updateJsValues());
    }
    /* ===== getters / setters ===== */
    get paymentAmounts() {
        return this._paymentAmounts;
    }
    set paymentAmounts(vals) {
        this.modified = true;
        this._paymentAmounts = vals.map((v) => (v instanceof TermPaymentAmount ? v : new TermPaymentAmount(v)));
    }
    /* ------ convenience collections ------ */
    get all() {
        return this._paymentAmounts;
    }
    get active() {
        return this._paymentAmounts.filter((p) => p.active);
    }
    /* ===== activation helpers ===== */
    deactivateAll() {
        this._paymentAmounts.forEach((p) => (p.active = false));
        this.modified = true;
        if (this.onChange)
            this.onChange();
    }
    activateAll() {
        this._paymentAmounts.forEach((p) => (p.active = true));
        this.modified = true;
        if (this.onChange)
            this.onChange();
    }
    /* ===== CRUD ===== */
    addPaymentAmount(pa) {
        this.modified = true;
        this._paymentAmounts.push(pa);
    }
    removePaymentAmountAtIndex(idx) {
        this.modified = true;
        this._paymentAmounts.splice(idx, 1);
    }
    removeAll() {
        this._paymentAmounts = [];
    }
    /* ===== look-ups ===== */
    get length() {
        return this._paymentAmounts.length;
    }
    atIndex(idx) {
        return this._paymentAmounts[idx];
    }
    get first() {
        return this._paymentAmounts[0];
    }
    get last() {
        return this._paymentAmounts[this._paymentAmounts.length - 1];
    }
    /** returns the *first active* override for the term (or undefined) */
    getPaymentAmountForTerm(termNumber) {
        return this._paymentAmounts.find((p) => p.active && p.termNumber === termNumber);
    }
    /* ===== utils ===== */
    isDuplicateTermNumber(termNumber) {
        return this._paymentAmounts.filter((p) => p.termNumber === termNumber).length > 1;
    }
    reSort() {
        this._paymentAmounts.sort((a, b) => a.termNumber - b.termNumber);
    }
    /* ===== serialization ===== */
    get json() {
        return this._paymentAmounts.map((p) => p.json);
    }
    toJSON() {
        return this.json;
    }
}
